module.exports = __webpack_public_path__ + "img/回单管理.93ca6bf9.svg";